import { render, staticRenderFns } from "./StockProductSelector.vue?vue&type=template&id=4c1270ce&scoped=true"
import script from "./StockProductSelector.vue?vue&type=script&lang=js"
export * from "./StockProductSelector.vue?vue&type=script&lang=js"
import style0 from "./StockProductSelector.vue?vue&type=style&index=0&id=4c1270ce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1270ce",
  null
  
)

export default component.exports